function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M2.88 7.5a.49.49 0 0 0-.48.5v8c0 .276.215.5.48.5H19.2a.49.49 0 0 0 .48-.5v-2.5h1.92v-3h-1.92V8a.49.49 0 0 0-.48-.5zm0-1.5H19.2c1.06 0 1.92.895 1.92 2v1h.96c.53 0 .96.448.96 1v4c0 .552-.43 1-.96 1h-.96v1c0 1.105-.86 2-1.92 2H2.88c-1.06 0-1.92-.895-1.92-2V8c0-1.105.86-2 1.92-2m1.44 3h2.4v6h-2.4a.49.49 0 0 1-.48-.5v-5c0-.276.215-.5.48-.5m3.36 0h2.88v6H7.68zm3.84 0h2.88v6h-2.88z",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/location/ic-battery-75.svg";
export { SvgComponent as ReactComponent };